import { Avatar, Card } from 'antd';
import Meta from 'antd/lib/card/Meta';
import "./infocardcomponent.css";

const InfoCardComponent = ({ avatar, title, description, onClick, icon, size }) => {
    return (
        <div>
            <Card
                className='cards-list-items cards-selected-items-container'
                onClick={onClick}
            >
                <Meta
                    avatar={avatar ? (
                        <Avatar
                            className='avatar-background'
                            size={size}
                        >
                            {avatar}
                        </Avatar>
                    ) : (
                        <Avatar
                            size={size}
                            icon={<img src={icon} alt="Avatar"/>}
                        />
                    )}
                    className='meta-title'
                    title={title}
                    description={description}
                />
            </Card>
        </div>
    );
};

export default InfoCardComponent;
